(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dma-footer"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = 'form.dma-footer__form';
  const removeFormAnchor = (form) => {
    const action = new URL(form.action, window.location.href);
    action.hash = '';
    form.action = action.href;
  };
  const restoreNewsletterView = () => {
    if (new URL(window.location.href).searchParams.get('customer_posted') !== 'true') return;
    const form = document.querySelector(selector);
    const message = form?.querySelector('.dma-footer__message[role="status"]');
    if (!form || !message) return;
    const current = new URL(window.location.href);
    if (current.hash && current.hash !== '#' + form.id) return;
    if (current.hash) {
      current.hash = '';
      window.history.replaceState(window.history.state, '', current.href);
    }
    const wrapper = form.closest('.page-wrapper');
    const overflow = wrapper ? window.getComputedStyle(wrapper).overflowY : '';
    const nestedScroll = wrapper && /^(auto|scroll)$/.test(overflow) && wrapper.scrollHeight > wrapper.clientHeight;
    if (nestedScroll) {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      const top = wrapper.scrollTop + message.getBoundingClientRect().top - wrapper.getBoundingClientRect().top - wrapper.clientHeight / 2;
      wrapper.scrollTo({ top: Math.max(0, top), behavior: 'instant' });
    } else {
      message.scrollIntoView({ block: 'center', behavior: 'instant' });
    }
    message.focus({ preventScroll: true });
  };
  const initialize = () => {
    document.querySelectorAll(selector).forEach(removeFormAnchor);
    window.requestAnimationFrame(restoreNewsletterView);
  };
  document.addEventListener('submit', (event) => {
    if (event.target instanceof HTMLFormElement && event.target.matches(selector)) {
      removeFormAnchor(event.target);
    }
  }, true);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
  window.addEventListener('load', restoreNewsletterView, { once: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
